module.exports = __webpack_public_path__ + "img/logo.8fb2ba94.webp";